jQuery(function($){
  
  // Logo list
  $('.logo-list-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
    //Scroll to reach
  $('.scroll-trigger a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    $('html, body').animate({
      'scrollTop': $target.offset().top
    }, 1000, 'swing');
  });

  // Product tab
  $('.product-description-tab  .tabmenu').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('#'+tab_id).siblings().removeClass('active');
    $('#'+tab_id).addClass('active');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  });

  $('.share-links').hide();  
  $('.share-trigger').click(function() {
    $('.share-links').slideToggle(100);
    return false;
  });
  
});

// jQuery(function($){
// 	$('.collection__filter--accordion-expanded').click(function(event){
      
//       //console.log($(this).hasClass('collection__filter--accordion-expanded'));
//       if($(this).hasClass('collection__filter--accordion-expanded'))
//       {
//         $(this).find('.collection__filter-container').css('display','none')
//       }
//       else
//       {
//       	$(this).find('.collection__filter-container').css('display','block')
//       }
//       //console.log($(this).find('.collection__filter-container').css('display','none'));
// 	});
// });  
$(document).on('click', '.add-product', function(event) {
	if($(this).find('input').prop('checked'))
  	{
         console.log('on');
         //console.log($(this).parent().find(".additional-selector-wrapper"))
  		 //$(this).parent().find(".additional-selector-wrapper-1").css("display","block");
         //$(this).parent().find(".additional-selector-wrapper-2").css("display","block");
         $('.additional_inputs').css("display","block");
         //console.log($("#radio1").prop("checked"))
         //$('select.product-form__variants').attr("name","id[]");
         $('input.first_input').attr("name","properties[first_inputs]");
         $('input.second_input').attr("name","properties[second_inputs]");
  	}
    else
    {
        console.log('off');
      	//$(this).parent().find(".additional-selector-wrapper-1").css("display","none");
        //$(this).parent().find(".additional-selector-wrapper-2").css("display","none");
        $('.additional_inputs').css("display","none");
      	$('select.product-form__variants').removeAttr("name");
    }
  });






// jQuery(function($){

//   if(!$('.add-bithdayplate').find('input').prop('checked'))
//   {
//     $('.birthday-name').find('input').removeAttr("name");
//     $(".additional-selector-wrapper").css("display","none");
//     $(".birthday-name").css("display","none");	
//      $('.add-on-product-options').removeAttr("name");
//     //$('select#Product-SingleOptionSelector-0-6719472369849').attr("name","id[]");

//   }
//   else
//   {
//     $('.birthday-name').find('input').attr("name","properties[name]");
//        $('.add-on-product-options').attr("name","id[]");
//   }


// });

/* Code For Adding Birthday Nameplate as a product */
$(document).on('click', '.add-bithdayplate', function(event) {
  if($(this).find('input').prop('checked'))
  {
    console.log('on');
    console.log($(this).parent().find(".additional-selector-wrapper"))
    $(this).parent().find(".additional-selector-wrapper").css("display","block");
    $(this).parent().find(".birthday-name").css("display","block");
    // $(this).parent().find('.add-on-product-options').attr("name","id[]");
    $(this).parent().find('.birthday-name').find('input').attr("name","properties[Gift note]");
    $(this).parent().find(".add-on-product-options").prop("checked", "checked");
  }
  else
  {
    console.log('off');
    console.log($('.add-bithdayplate').find('input').prop('checked'));
    $(this).parent().find(".additional-selector-wrapper").css("display","none");
    $(this).parent().find(".birthday-name").css("display","none");
    // $(this).parent().find('.add-on-product-options').removeAttr("name");
    $(this).parent().find('.birthday-name').find('input').removeAttr("name");
  }    
});
$("form.productForm").submit(function(e){
  var formId = $(this).attr('id');
  console.log(formId);
  if($('.add-bithdayplate input').prop('checked'))
  {
    e.preventDefault();
    console.log('checked');
    // window.setTimeout($('#'.formId).submit(), 5000);
    var gift_card_note = $('.birthday-name').find('textarea#gift-note').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: 40870658703557,
        properties: {
          'Gift Note': gift_card_note
        }
      },
      dataType: 'json', 
      success: function (data) { 
        console.log(data.quantity);
		document.getElementById(formId).submit();
      } 
    });
    //window.setTimeout(document.getElementById(formId).submit(), 5000);
  }
  else
  {
    console.log('not checked');
  }
});

$(document).ready(function(){
  $('body').on('click', '.cart-product__quantity .inputCounter__btn, .addNoteButton', function(event) {
    jQuery('.cart-form input[name="acceptance"]').trigger('click').css('opacity','0.1');
    jQuery('.cart-form input[name="update"]').trigger('click');
  }); 
  $('.inputCounter').on('change',function(){
  	jQuery('.cart-form input[name="update"]').trigger('click');
  });
});

